import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CreateManufacturerPayload } from "../../../products/types";
import api from "../../http";
import { getApiErrorMessage, toApiError } from "../utils";

export const useUpdateManufacturer = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ({ id, data }: { id: string; data: CreateManufacturerPayload }) => {
            try {
                return (await api.put(`/manufacturer/update/${id}`, data)).data;
            } catch (error) {
                throw toApiError(error, 'Erro ao atualizar fabricante');
            }
        },
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: ['manufacturers'] });
            queryClient.invalidateQueries({ queryKey: ['manufacturer', variables.id] });
        },
        onError: (error) => {
            console.error('Erro ao atualizar fabricante:', getApiErrorMessage(error, 'Erro ao atualizar fabricante'))
        },
    });
};
